import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import Authentication from "./Authentication";
import SubUserSlice from "./SubUserId"
import { persistReducer, persistStore } from "redux-persist";
import formSlice from "./formSlice";

const reducers = combineReducers({
  Authlogin: Authentication,
  SubUser: SubUserSlice,
  form: formSlice,
});
const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
  reducer: persistedReducer,
});
// const store = configureStore({
//   reducer: reducers,
// });
export default store;
export const persistor = persistStore(store);
